<template lang='html'>
  <d-container fluid class='main-content-container px-3'>
    <d-row class="mb-4">
      <d-col cols="auto" class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
        <div class="date-range">
          <d-input-group class="d-flex justify-content-left mb-2 mb-sm-0">
            <datepicker-interval
              :dateTo.sync="dateRange.to"
              :dateFrom.sync="dateRange.from"
              :on-clear="clear"
            />
          </d-input-group>
        </div>
        <d-button type="button" @click.prevent="getResellerStats" size="sm" class="btn-primary ml-0 ml-sm-3">Filtrar</d-button>
      </d-col>
    </d-row>
    <!-- Small Stats Blocks -->
    <d-row>
      <d-col lg v-for='(stats, idx) in smallStats' :key='idx' class='mb-4'>
        <small-stats :id='`small-stats-${idx}`' variation='1' :chart-data='stats.datasets' :label='stats.label' :value='stats.value' :percentage='stats.percentage' :increase='stats.increase' :decrease='stats.decrease' />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import SmallStats from '_common/components/dashboard/SmallStats.vue';
import DatepickerInterval from '_common/shared/DatepickerInterval.vue';
import ResellerService from '_services/rest/modules/distributor';

export default {
  name: 'reseller-indicators',
  components: {
    SmallStats,
    DatepickerInterval
  },
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      smallStats: [],
      dateRange: {
        from: null,
        to: null,
      },
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    clear() {
      this.getResellerStats();
    },
    getResellerStats() {
      this.setToggle({ type: 'progress', bool: true });
      ResellerService.getIndicators(this.id, this.dateRange)
        .then(response => {
          this.setToggle({ type: 'progress', bool: false });
          this.smallStats = response;
        });
    },
  },
  mounted() {
    if (this.id) {
      this.getResellerStats();
    }
  },
};
</script>

<style lang='scss' scoped>
.date-range {
  width: 14.5em;
}
</style>
